// Fallback do gating por papel — SOMENTE para quando a API ainda nao fala
// RBAC configuravel (auth response sem o campo `capabilities`, ou seja, API
// anterior a migracao 0024). Reproduz byte a byte o gating de HOJE (antes
// deste plano), medido em docs/specs/2026-09-23-rbac-configuravel-plan.md
// secao 6 (CHECK 0, coluna "antes"): admin tinha Categorias/Tags/Tecnicidades/
// Usuarios/Notificacoes/Log + todos os canais, mas NAO Estoques/Frentes &
// canais/Configuracoes (superOnly). usuario so os canais liberados.
//
// NUNCA usar isto quando `capabilities` esta presente (mesmo vazio []) —
// nesse caso o perfil e real e configuravel, e um array vazio e uma resposta
// valida (perfil sem nenhuma capacidade), nao uma API velha.
import type { CapabilityKey, Role } from "./types";

// super_admin nunca consulta este mapa: AuthContext.can() faz o bypass RN23
// (role === "super_admin" -> true) antes de olhar aqui. Mantido aqui so por
// completude/documentacao.
const LEGACY_CAPS: Record<string, CapabilityKey[]> = {
  admin: [
    "products.read",
    "products.write",
    "products.publish",
    "photos.write",
    "ai.generate",
    "channels.all",
    "categories.write",
    "tags.write",
    "technicalities.write",
    "care_instructions.write",
    "size_guides.write",
    "users.manage",
    "audit.read",
    "notifications.read",
  ],
  usuario: ["products.read", "products.write", "products.publish", "photos.write", "ai.generate"],
};

export function legacyCapsForRole(role: Role): Set<CapabilityKey> {
  return new Set(LEGACY_CAPS[role] ?? []);
}
